// src/components/site/Content.tsx
import React from "react";

type Props = {
  children: React.ReactNode;
  /** "narrow" (default, ~max-w-3xl) or "wide" (~max-w-5xl) */
  width?: "narrow" | "wide";
  className?: string;
};

export default function Content({ children, width = "narrow", className = "" }: Props) {
  const widthCls = width === "wide" ? "max-w-5xl" : "max-w-3xl";
  return <div className={`mx-auto ${widthCls} ${className}`.trim()}>{children}</div>;
}
